module.exports = __webpack_public_path__ + "static/stories-0944f7697f11e6afcfff268969be8e92.jpg";